module.exports = __webpack_public_path__ + "media/images/users/profile-f98e060052075493c25d5cfc24042245.svg";